import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { ActiveFilters } from "./utils";

/**
 * Ф4б: серверное состояние уехало в TanStack. В слайсе остаётся то, что
 * ввёл пользователь, — поисковый запрос и активные фильтры. Производные
 * (список, группировка, счётчики) считает utils.ts над данными TanStack,
 * а не редьюсер.
 */
interface MenuState {
  searchQuery: string;
  activeFilters: ActiveFilters;
}

// Фабрика, а не общий литерал: общий объект делил бы массивы между
// initialState и результатом clearFilters.
const emptyFilters = (): ActiveFilters => ({
  tagsInclude: [],
  tagsExclude: [],
  isActive: true,
});

const initialState: MenuState = {
  searchQuery: "",
  activeFilters: emptyFilters(),
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    clearSearch: (state) => {
      state.searchQuery = "";
    },
    applyFilters: (state, action: PayloadAction<ActiveFilters>) => {
      const { payload } = action;

      // Обновляем по одному полю, а не спредом: FilterModal шлёт
      // sortByPrice: undefined осознанно — это «сброс сортировки», и спред
      // затирал бы им поле вместо снятия только этого ключа.
      if (payload.tagsInclude !== undefined) {
        state.activeFilters.tagsInclude = payload.tagsInclude;
      }
      if (payload.tagsExclude !== undefined) {
        state.activeFilters.tagsExclude = payload.tagsExclude;
      }
      if (payload.categoryId !== undefined) {
        state.activeFilters.categoryId = payload.categoryId;
      }
      if (payload.isActive !== undefined) {
        state.activeFilters.isActive = payload.isActive;
      }
      if (payload.sortByCategoryId !== undefined) {
        state.activeFilters.sortByCategoryId = payload.sortByCategoryId;
      }
      if ("sortByPrice" in payload) {
        if (payload.sortByPrice === undefined) {
          delete state.activeFilters.sortByPrice;
        } else {
          state.activeFilters.sortByPrice = payload.sortByPrice;
        }
      }
    },
    clearFilters: (state) => {
      state.activeFilters = emptyFilters();
    },
  },
});

export const { setSearchQuery, clearSearch, applyFilters, clearFilters } =
  menuSlice.actions;

export default menuSlice.reducer;
